import styled from "@emotion/styled";
import { Theme } from "@emotion/react";
import Grid from "@material-ui/core/Grid";

export const TooltipDiv = styled.div`
  border: ${(props) => `solid 1px ${props.theme.colors.slightLightGray}`};
  box-shadow: ${(props) => `0 0 10px 1px ${props.theme.colors.slightLightGray}`};
  background-color: ${(props) => props.theme.colors.white};

  color: 000;
  z-index: 1;
  border-radius: 2px;

  padding: 12px;
  position: absolute;

  width: 225px;
  height: 100px;

  top: -105px;
  left: -112px;

  animation: fadeIn 0.5s;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  &:before {
    content: "";
    display: block;
    position: absolute;
    left: 112px;
    top: 100%;
    border-width: 8px;
    border-style: solid;
    border-color: ${(props) =>
      `${props.theme.colors.slightLightGray} transparent transparent transparent`};
  }

  &:after {
    content: "";
    display: block;
    position: absolute;
    left: 113px;
    top: 100%;
    border-width: 7px;
    border-style: solid;
    border-color: ${(props) => `${props.theme.colors.white} transparent transparent transparent`};
  }
`;

interface TooltipContentProps {
  colour?: string;
  theme?: Theme;
}

export const TooltipContent = styled(Grid)`
  color: ${(props: TooltipContentProps) => {
    return props.colour;
  }};
`;
